export default __webpack_public_path__ + "static/media/tag-blue.3ea8eba9.svg";